module.exports = __webpack_public_path__ + "media/images/banner-1-25af02f1dc6554c8bae7b80e0d7baa91.png";